// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ProcessedColorValue, ViewProps } from 'react-native';
import type { DirectEventHandler, Int32, Double, WithDefault } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
type OneNativeStyleNative = Readonly<{
  fontSize?: WithDefault<Double, -1>;
  fontWeight?: string;
  fontDesign?: string;
  textStyle?: string;
  foregroundStyle?: ProcessedColorValue;
  tint?: ProcessedColorValue;
  background?: ProcessedColorValue;
  padding?: WithDefault<Double, -1>;
  paddingTop?: WithDefault<Double, -1>;
  paddingLeading?: WithDefault<Double, -1>;
  paddingBottom?: WithDefault<Double, -1>;
  paddingTrailing?: WithDefault<Double, -1>;
  width?: WithDefault<Double, -1>;
  height?: WithDefault<Double, -1>;
  minWidth?: WithDefault<Double, -1>;
  idealWidth?: WithDefault<Double, -1>;
  maxWidth?: WithDefault<Double, -1>;
  minHeight?: WithDefault<Double, -1>;
  idealHeight?: WithDefault<Double, -1>;
  maxHeight?: WithDefault<Double, -1>;
  cornerRadius?: WithDefault<Double, -1>;
  opacity?: WithDefault<Double, -1>;
  borderColor?: ProcessedColorValue;
  borderWidth?: WithDefault<Double, -1>;
  glassEffect?: string;
  glassEffectInteractive?: boolean;
  glassEffectTint?: ProcessedColorValue;
  glassEffectShape?: string;
  material?: string;
  sdkModifiers?: string;
}>;
interface NativeProps extends ViewProps {
  selection: string;
  tabViewStyle: string;
  tabBarVisibility: string;
  customization: string;
  customizable: boolean;
  bottomAccessoryEnabled: boolean;
  acknowledgedEvent: Int32;
  revision: Int32;
  swiftStyle?: OneNativeStyleNative;
  onNativeTabsSelectionChange?: DirectEventHandler<Readonly<{
    selection: string;
    eventCount: Int32;
    revision: Int32;
  }>>;
  onNativeTabsAction?: DirectEventHandler<Readonly<{
    tabId: string;
  }>>;
  onNativeTabsCustomizationChange?: DirectEventHandler<Readonly<{
    customization: string;
  }>>;
  onNativeSDKEvent?: DirectEventHandler<Readonly<{
    name: string;
    value: string;
  }>>;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
let nativeComponentName = 'OneNativeTabs';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeTabs",
  directEventTypes: {
    topNativeTabsSelectionChange: {
      registrationName: "onNativeTabsSelectionChange"
    },
    topNativeTabsAction: {
      registrationName: "onNativeTabsAction"
    },
    topNativeTabsCustomizationChange: {
      registrationName: "onNativeTabsCustomizationChange"
    },
    topNativeSDKEvent: {
      registrationName: "onNativeSDKEvent"
    }
  },
  validAttributes: {
    selection: true,
    tabViewStyle: true,
    tabBarVisibility: true,
    customization: true,
    customizable: true,
    bottomAccessoryEnabled: true,
    acknowledgedEvent: true,
    revision: true,
    swiftStyle: true,
    ...ConditionallyIgnoredEventHandlers({
      onNativeTabsSelectionChange: true,
      onNativeTabsAction: true,
      onNativeTabsCustomizationChange: true,
      onNativeSDKEvent: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);